import React from "react";
import { Box, Typography } from "@material-ui/core";
import { ReportOutlined } from "@material-ui/icons";

export const VulnerabilityChipError: React.FC = ({ children }) => (
  <Box color="#B22E2A" display="flex" data-testid="VulnerabilityChipError">
    <Box display="flex" alignItems="center">
      <ReportOutlined width={16} height={16} fill="currentColor" />
    </Box>
    <Box ml={0.5} display="flex" alignItems="center">
      <Typography variant="caption">{children}</Typography>
    </Box>
  </Box>
);
